/**
 * @fileoverview Which ready-made PDF a Day One document downloads as
 * (MOR-2342 BKY-09). Shared by the single-document download menu and the
 * bulk Word / PDF handlers so a selected PDF form is never silently left
 * out of a bulk export.
 *
 * A document is served as a ready-made PDF rather than rendered from HTML
 * in two cases:
 *   1. A PDF-form template with a filled PDF (`filledPdfUrl`).
 *   2. A flat form PDF with no body HTML and no fillable fields — the only
 *      faithful output is the original uploaded file (`sourceDocumentUrl`).
 * The Gallagher notification is a web-portal form and never a direct PDF.
 * A document whose fill failed has NO current PDF (see fillErrorGuard).
 */

import { fillBlockReason } from "./fillErrorGuard";

export interface DirectPdfDoc {
  templateKey: string;
  filledPdfUrl?: string | null;
  editedHtml?: string | null;
  pdfFillError?: string | null;
}

export interface DirectPdfTemplate {
  sourceDocumentUrl?: string | null;
  templateHtml?: string | null;
}

/** The ready-made PDF URL for this document, or null when it renders from HTML. */
export function resolveDirectPdfUrl(
  doc: DirectPdfDoc,
  template: DirectPdfTemplate | undefined,
): string | null {
  if (fillBlockReason(doc)) return null;
  if (doc.filledPdfUrl) return doc.filledPdfUrl;
  if (
    doc.templateKey !== "form_gallagher" &&
    template?.sourceDocumentUrl &&
    !template.templateHtml &&
    !doc.editedHtml
  ) {
    return template.sourceDocumentUrl;
  }
  return null;
}
